import TMain from '../templates/main';
import useSection from '@shared/components/utils/hooks/useSection';
import { QuerySections } from '@shared/types/enums/sections';

/**
 * Shows page component that displays shows content with highlights and reels.
 * Starts navigation in menu
 */
export default function Shows() {
  const { complete, highlights, reels, onPagination } = useSection({
    section: QuerySections.SHOWS,
  });

  return (
    <TMain
      complete={complete}
      rails={reels}
      sliders={highlights}
      hideBackground={true}
      startsInMenu
      startsInSlider
      onPagination={onPagination}
    />
  );
}
